import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Logger } from '../logger';
export var COOKIE_CACHE_URL_PROD = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';

/**
 * Cache variable for storing categorized cookies cache
 */
var localResponseCache;

/**
 * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
 *
 * Allows for many invocations to happen simultaneously, and for only one fetch to go out
 */
var localResponsePromiseCache;

/**
 * Cache variable for storing the promise returned from the response object's json method
 *
 * Ensures we don't invoke response.json multiple times
 */
var localResponseJsonPromiseCache;
export var clearStorageControlsDataCache = function clearStorageControlsDataCache() {
  localResponseCache = undefined;
  localResponsePromiseCache = undefined;
  localResponseJsonPromiseCache = undefined;
};

/**
 * Unpacks the response promise from the categories CDN
 *
 * errors if that request was unsuccessful, returns the categories data otherwise
 *
 */
var handleCategoriesResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(responsePromise) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (responsePromise) {
            _context.next = 2;
            break;
          }
          throw new Error("Failed to fetch Cookies Cache! Cached promise was undefined");
        case 2:
          _context.next = 4;
          return responsePromise;
        case 4:
          response = _context.sent;
          if (response.ok) {
            _context.next = 7;
            break;
          }
          throw new Error("Failed to fetch Cookies Cache! status: ".concat(response.status));
        case 7:
          // Checks if we've already fired the response.json() promise
          localResponseJsonPromiseCache = localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
          return _context.abrupt("return", localResponseJsonPromiseCache);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleCategoriesResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var loadStorageControlsData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!localResponseCache) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", localResponseCache);
        case 4:
          _context2.prev = 4;
          if (!localResponsePromiseCache) {
            // invoke CDN and cache the promise
            localResponsePromiseCache = fetch(COOKIE_CACHE_URL_PROD);
          }

          // unpack response
          _context2.next = 8;
          return handleCategoriesResponse(localResponsePromiseCache);
        case 8:
          localResponseCache = _context2.sent;
          return _context2.abrupt("return", localResponseCache);
        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](4);
          Logger.errorWithOperationalEvent({
            action: 'loadStorageControlsError',
            message: _context2.t0.message || ''
          });
          clearStorageControlsDataCache();
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 12]]);
  }));
  return function loadStorageControlsData() {
    return _ref2.apply(this, arguments);
  };
}();